var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFourStacks = function SvgFourStacks(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.5 2H3.75A1.75 1.75 0 002 3.75v8.75c0 .966.784 1.75 1.75 1.75h8.75a1.75 1.75 0 001.75-1.75V3.75A1.75 1.75 0 0012.5 2zm-1.75 8.75H5.5V5.5h5.25v5.25zM28.25 17.75H19.5a1.75 1.75 0 00-1.75 1.75v8.75c0 .966.784 1.75 1.75 1.75h8.75A1.75 1.75 0 0030 28.25V19.5a1.75 1.75 0 00-1.75-1.75zM26.5 26.5h-5.25v-5.25h5.25v5.25zM12.5 17.75H3.75A1.75 1.75 0 002 19.5v8.75c0 .966.784 1.75 1.75 1.75h8.75a1.75 1.75 0 001.75-1.75V19.5a1.75 1.75 0 00-1.75-1.75zm-1.75 8.75H5.5v-5.25h5.25v5.25zM23.875 14.25a1.75 1.75 0 01-1.237-.513l-4.375-4.375a1.75 1.75 0 010-2.475l4.375-4.375a1.75 1.75 0 012.474 0l4.375 4.375a1.75 1.75 0 010 2.475l-4.375 4.375a1.75 1.75 0 01-1.237.513z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFourStacks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/four-stacks.fd0acaf99fc5b30b2d98cd61ab203cf0.svg";